import {
  getDeptListEnable2,
  user_inDepts2,
  getDeptListEnable,
  user_inDepts
} from '@/api/system.js'
import {dict} from '@/api/assetmenag'

//返回部门
//分类
function buildtree(list, arr, parentId) {
  list.forEach(item => {
    if (item.parentId === parentId) {
      var child = {
        key: item.deptId,
        value: item.deptId + '',
        label: item.deptName,
        children: []
      }
      buildtree(list, child.children, item.deptId)
      arr.push(child)
    }
  })
  return arr
}
export function returnDept(cb) {
  getDeptListEnable().then(respon => {
    var lis = respon.rows;
    var news_arr = []
    let as = buildtree(lis, news_arr, 0);
    var columns = [{
      values: as,
    }, {
      values: as[0].children,
    }]
    var obj = {
      columns: columns,
      depts: as
    }
    cb && cb(obj)
  })
}

// 查询所有当前部门中的用户
export function get_users(id, cb) {
  user_inDepts({
    deptId: id
  }).then(res => {
    cb && cb(res.rows)
  })
}
export function returnDept2(cb) {
  getDeptListEnable2().then(respon => {
    var lis = respon.rows;
    var news_arr = []
    let as = buildtree(lis, news_arr, 0);
    var columns = [{
      values: as,
    }, {
      values: as[0].children,
    }]
    var obj = {
      columns: columns,
      depts: as
    }
    cb && cb(obj)
  })
}

// 查询所有当前部门中的用户
export function get_users2(id, cb) {
  user_inDepts2({
    deptId: id
  }).then(res => {
    cb && cb(res.rows)
  })
}

//获取物品状态
export function get_dict(type,cb){
  dict({dictType:type,status:0}).then(res=>{
    var lis={}
    res.rows.forEach(item=>{
      lis[item.dictValue]=item.dictLabel
    })
      cb&&cb(lis)
  })
}